import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { EditorComponent } from '../../../base/editor/editor.component';
import { HistoryComponent } from '../../../fragments/history/history.component';
import { AppService } from '../../../../services/app.service';
import { SearchRequestService } from '../../../../services/search-requests/search-request.service';
import { Location } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { SearchRequestEnvelope } from '../../../../models/net/envelope/search-request-envelope';
import { SearchRequestDocument } from '../../../../models/net/envelope/documents/search-request-document';
import { SearchRequestType } from '../../../../models/data/app-core/search-request-type';

@Component({
    selector: 'app-search-request',
    templateUrl: './search-request.component.html',
    styleUrls: ['./search-request.component.css', '../../../../app.component.css']
})

export class SearchRequestComponent extends EditorComponent implements AfterViewInit {

    public resourceSearchRequestJson: string = "{}";
    public searchRequestTypes: SearchRequestType[] = [];

    @ViewChild("appHistory") appHistory!: HistoryComponent;

    public constructor(public override appService: AppService,
                       public override itemService: SearchRequestService, 
                       public override route: ActivatedRoute,
                       public override location: Location) {

        super(appService, itemService, route, location, "searchrequest", "searchrequests");
    }

    public override handleEditMode = (): void => {

        this.appService.navigateTo("searchrequest/" + this.itemId.toString(), "");
    }

    public override initializeEnvelope = (envelope: SearchRequestEnvelope | null): void => {

        super.initializeEnvelope(envelope);

        this.itemEnvelope = new SearchRequestEnvelope(envelope);
        this.itemEnvelopeSnapshot = this.appService.cloneObject(this.itemEnvelope);

        this.searchRequestTypes = (this.itemEnvelope as SearchRequestEnvelope).SearchRequestTypes;

        const searchRequestJsonObject: any = JSON.parse((this.itemEnvelope?.Document as SearchRequestDocument).Item.SearchRequestJson);
        this.resourceSearchRequestJson = JSON.stringify(searchRequestJsonObject, null, 2);
    }

    public ngAfterViewInit() {

        this.appHistory.searchRevisions();
    }
}
